// Landing pages por tipo de propiedad: /Venta/casas, /Alquiler/locales-comerciales, etc.
//
// Es lo que hace la competencia local (Kevel tiene 12 paginas de este tipo) y
// es lo que permite rankear para busquedas como "casas en venta catamarca" o
// "terrenos en venta catamarca", que hoy no tienen ninguna pagina propia.
//
// El campo `tipo` tiene que coincidir con el nombre canonico que devuelve
// GET /tipos de la API (api/src/config/tiposPropiedad.js), porque el filtrado
// se hace comparando contra el tipo ya normalizado que guarda el backend.

export const TIPOS_LANDING = [
  { slug: "casas", tipo: "Casa", plural: "Casas" },
  { slug: "departamentos", tipo: "Departamento", plural: "Departamentos" },
  { slug: "ph", tipo: "PH", plural: "PH" },
  { slug: "terrenos", tipo: "Terreno", plural: "Terrenos y lotes" },
  { slug: "locales-comerciales", tipo: "Local comercial", plural: "Locales comerciales" },
  { slug: "oficinas", tipo: "Oficina", plural: "Oficinas" },
  { slug: "galpones", tipo: "Galpón", plural: "Galpones y depósitos" },
  { slug: "cocheras", tipo: "Cochera", plural: "Cocheras" },
  { slug: "campos", tipo: "Campo", plural: "Campos y quintas" },
];

export const buscarLanding = (slug) =>
  TIPOS_LANDING.find((t) => t.slug === slug) || null;

// Textos de SEO por combinacion tipo + operacion.
export const seoDeLanding = (landing, operacion) => {
  const enVenta = operacion === "Venta";
  const accion = enVenta ? "en venta" : "en alquiler";
  const verbo = enVenta ? "Comprá" : "Alquilá";
  const plural = landing.plural.toLowerCase();

  return {
    title: `${landing.plural} ${accion} en Catamarca | AMARCA Inmobiliaria`,
    description: `${verbo} ${plural} ${accion} en San Fernando del Valle de Catamarca. Publicaciones actualizadas de AMARCA Inmobiliaria, con más de 20 años en el mercado catamarqueño.`,
    keywords: `${plural} ${accion} catamarca, ${plural} catamarca, ${landing.tipo.toLowerCase()} ${accion} san fernando del valle, inmobiliaria catamarca`,
    h1: `${landing.plural} ${accion} en Catamarca`,
    subtitulo: enVenta
      ? `Encontrá ${plural} en venta en San Fernando del Valle de Catamarca`
      : `Encontrá ${plural} en alquiler en San Fernando del Valle de Catamarca`,
    vacio: `Por el momento no hay ${plural} ${accion}`,
  };
};
